import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the recently deleted date sort being applied',
  name: 'recently_deleted_sort_applied',
  params: [
    {
      description: 'The sort type for recently deleted',
      name: 'sort_type',
      required: true,
      type: 'string',
    },
    {
      description: 'The sort direction for recently deleted',
      name: 'sort_direction',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
